import React, { useEffect, useState } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { DASHBOARD_FILTERS } from "../../../constants/DashboardFilter";
import { GetColor } from "../../../utils/array";
import { DisplayMsg } from "../../../services/toastService";
import {
  clearTicketTaskFilters,
  setTicketTaskAllFilters,
} from "../../../store/reducers/TicketTaskFilter";
import { setUrl } from "../../../handlers";
import { setCurrentTab, setQuickSearch } from "../../../store/reducers/SharedLayoutDataSlice";

const Implementation = () => {
  const dispatch = useDispatch();
  const [impAssigneeCounts, setAssigneeCount] = useState([]);
  const [impTeamCounts, setTeamCount] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    LoadImplementation();
  }, []);

  const LoadImplementation = async () => {
    try {
      document.getElementById("loader").style.display = "block";
      const result = await fetch(setUrl("HOME", "LOADIMPDASHBOARD", true));
      const response = await result.json();
      if (response.status) {
        setAssigneeCount(response.AssigneeCounts);
        setTeamCount(response.TeamCount);
        StatusCountsGraph(response.StatusCounts);
        PriorityCountsGraph(response.PriorityCounts);
      }
      if (
        response?.status === false &&
        response?.Message ===
        "Collection was modified; enumeration operation may not execute."
      ) {
        LoadImplementation();
      }

      document.getElementById("loader").style.display = "none";
    } catch (e) {
      DisplayMsg("2", "Unable to Process the Request");
    }
  };

  const ShowImplementData = (type, value) => {
    dispatch(setQuickSearch(false));
    dispatch(setCurrentTab("tickets"));
    dispatch(clearTicketTaskFilters());
    if (type === "status") {
      dispatch(
        setTicketTaskAllFilters({
          status: value,
          teamCategory: "Implementation",
          type: "Ticket",
          currentPage: 1,
          suspended: "N",
        })
      );
    } else if (type === "priority") {
      dispatch(
        setTicketTaskAllFilters({
          status: "",
          teamCategory: "Implementation",
          priority: value,
          type: "Ticket",
          currentPage: 1,
          suspended: "N",
        })
      );
    } else if (type === "assignee") {
      dispatch(
        setTicketTaskAllFilters({
          type: "Ticket",
          status: "FU",
          teamCategory: "Implementation",
          suspended: "N",
          assignee: value.toUpperCase(),
          currentPage: 1,
        })
      );
    } else if (type === "teams") {
      dispatch(
        setTicketTaskAllFilters({
          type: "Ticket",
          team: value,
          status: "FU",
          teamCategory: "Implementation",
          suspended: "N",
          currentPage: 1,
        })
      );
    }

    navigate("/tickets");
  };

  const PriorityCountsGraph = (ImpPriorityData) => {
    const priorityarray = [];
    const updatePriority = [];
    if (ImpPriorityData.length === DASHBOARD_FILTERS.IMPPRIORITY_ARRAY.length) {
      ImpPriorityData.forEach((item) => {
        priorityarray.push({ label: item.label, data: item.data });
      });
    } else {
      let medium = true;
      let low = true;
      let high = true;
      let citical = true;
      ImpPriorityData.forEach((item) => {
        if (item.label.toUpperCase() === "MEDIUM") {
          medium = false;
        } else if (item.label.toUpperCase() === "LOW") {
          low = false;
        } else if (item.label.toUpperCase() === "HIGH") {
          high = false;
        } else {
          citical = false;
        }
        priorityarray.push({ label: item.label, data: item.data });
      });
      if (medium) {
        ImpPriorityData.push(DASHBOARD_FILTERS.IMPPRIORITY_ARRAY[0]);
        priorityarray.push({
          label: DASHBOARD_FILTERS.IMPPRIORITY_ARRAY[0].label,
          data: DASHBOARD_FILTERS.IMPPRIORITY_ARRAY[0].data,
        });
      }
      if (low) {
        ImpPriorityData.push(DASHBOARD_FILTERS.IMPPRIORITY_ARRAY[1]);
        priorityarray.push({
          label: DASHBOARD_FILTERS.IMPPRIORITY_ARRAY[1].label,
          data: DASHBOARD_FILTERS.IMPPRIORITY_ARRAY[1].data,
        });
      }
      if (high) {
        ImpPriorityData.push(DASHBOARD_FILTERS.IMPPRIORITY_ARRAY[2]);
        priorityarray.push({
          label: DASHBOARD_FILTERS.IMPPRIORITY_ARRAY[2].label,
          data: DASHBOARD_FILTERS.IMPPRIORITY_ARRAY[2].data,
        });
      }
      if (citical) {
        ImpPriorityData.push(DASHBOARD_FILTERS.IMPPRIORITY_ARRAY[3]);
        priorityarray.push({
          label: DASHBOARD_FILTERS.IMPPRIORITY_ARRAY[3].label,
          data: DASHBOARD_FILTERS.IMPPRIORITY_ARRAY[3].data,
        });
      }
    }

    am4core.useTheme(am4themes_animated);
    const Priorityamchart = am4core.create("ImpPriority_Count", "PieChart");

    const series = Priorityamchart.series.push(new am4charts.PieSeries());
    series.dataFields.value = "data";
    series.dataFields.category = "label";
    series.labels.template.disabled = true;
    series.ticks.template.disabled = true;
    series.alignLabels = true;
    const rgm = new am4core.RadialGradientModifier();
    rgm.brightnesses.push(0.7, 0.7, 0.7, 0.7, 0.3);
    series.slices.template.fillModifier = rgm;
    series.slices.template.strokeModifier = rgm;
    series.slices.template.strokeOpacity = 0.4;
    series.slices.template.strokeWidth = 0;

    Priorityamchart.legend = new am4charts.Legend();
    series.slices.template.events.on("hit", (event) => { });
    Priorityamchart.legend = new am4charts.Legend();

    Priorityamchart.legend.position = "left";
    Priorityamchart.legend.fontSize = 14;
    Priorityamchart.legend.labels.template.maxWidth = 12;
    Priorityamchart.logo.disabled = true;
    Priorityamchart.legend.valueLabels.template.position = "left";
    Priorityamchart.legend.valueLabels.template.align = "left";
    Priorityamchart.legend.labels.template.text =
      "[{color}] {data}   {category} ";
    Priorityamchart.legend.valueLabels.template.text = "";
    Priorityamchart.legend.itemContainers.template.togglable = false;
    Priorityamchart.legend.itemContainers.template.events.on("hit", (ev) => {
      if (
        ev.target.dataItem.dataContext.category.toUpperCase() === "CRITICAL"
      ) {
        ShowImplementData("priority", "Critical");
      } else if (
        ev.target.dataItem.dataContext.category.toUpperCase() === "HIGH"
      ) {
        ShowImplementData("priority", "High");
      } else if (
        ev.target.dataItem.dataContext.category.toUpperCase() === "MEDIUM"
      ) {
        ShowImplementData("priority", "Medium");
      } else {
        ShowImplementData("priority", "Low");
      }
    });

    let label = "Critical";

    priorityarray.forEach((item) => {
      const data = priorityarray.find((item) => item.label === label);
      if (label === "Critical") {
        label = "High";
      } else if (label === "High") {
        label = "Medium";
      } else if (label === "Medium") {
        label = "Low";
      } else if (label === "Low") {
        label = "Low";
      }
      updatePriority.push(data);
    });
    Priorityamchart.data = updatePriority;
    series.colors.list = [
      am4core.color(GetColor(ImpPriorityData[0].color)),
      am4core.color(GetColor(ImpPriorityData[3].color)),
      am4core.color(GetColor(ImpPriorityData[1].color)),
      am4core.color(GetColor(ImpPriorityData[2].color)),
    ];
  };

  const StatusCountsGraph = (ImpStatusData) => {
    const statusarray = [];
    const updatedStatus = [];

    if (ImpStatusData.length !== DASHBOARD_FILTERS.STATUS_ARRAY.length) {
      ImpStatusData.forEach((item) => {
        statusarray.push({ label: item.label, data: item.data });
      });

      const data = {
        data: 0,
        label: "Reopened",
      };
      statusarray.push(data);
    } else {
      let resolved = true;
      let inProgress = true;
      let pendingOnClient = true;
      let open = true;
      let reopened = true;
      ImpStatusData.forEach((item) => {
        if (item.label.toUpperCase() === "RESOLVED") {
          resolved = false;
        } else if (item.label.toUpperCase() === "IN PROGRESS") {
          inProgress = false;
        } else if (item.label.toUpperCase() === "PENDING ON CLIENT") {
          pendingOnClient = false;
        } else if (item.label.toUpperCase() === "OPEN") {
          open = false;
        } else {
          reopened = true;
        }
        statusarray.push({ label: item.label, data: item.data });
      });
      if (resolved) {
        ImpStatusData.push(DASHBOARD_FILTERS.STATUS_ARRAY[0]);
        statusarray.push({
          label: DASHBOARD_FILTERS.STATUS_ARRAY[0].label,
          data: DASHBOARD_FILTERS.STATUS_ARRAY[0].data,
        });
      }
      if (inProgress) {
        ImpStatusData.push(DASHBOARD_FILTERS.STATUS_ARRAY[1]);
        statusarray.push({
          label: DASHBOARD_FILTERS.STATUS_ARRAY[1].label,
          data: DASHBOARD_FILTERS.STATUS_ARRAY[1].data,
        });
      }
      if (pendingOnClient) {
        ImpStatusData.push(DASHBOARD_FILTERS.STATUS_ARRAY[2]);
        statusarray.push({
          label: DASHBOARD_FILTERS.STATUS_ARRAY[2].label,
          data: DASHBOARD_FILTERS.STATUS_ARRAY[2].data,
        });
      }
      if (open) {
        ImpStatusData.push(DASHBOARD_FILTERS.STATUS_ARRAY[3]);
        statusarray.push({
          label: DASHBOARD_FILTERS.STATUS_ARRAY[3].label,
          data: DASHBOARD_FILTERS.STATUS_ARRAY[3].data,
        });
      }
    }

    am4core.useTheme(am4themes_animated);
    const Statusamchart = am4core.create("ImpStatus_Count", "PieChart");

    const series = Statusamchart.series.push(new am4charts.PieSeries());
    series.dataFields.value = "data";
    series.dataFields.category = "label";
    series.labels.template.disabled = true;
    series.ticks.template.disabled = true;

    series.alignLabels = true;
    const rgm = new am4core.RadialGradientModifier();
    rgm.brightnesses.push(0.3, 0.3, 0.3, 0.3, 0);
    series.slices.template.fillModifier = rgm;
    series.slices.template.strokeModifier = rgm;
    series.slices.template.strokeOpacity = 0.2;
    series.slices.template.strokeWidth = 4;

    Statusamchart.legend = new am4charts.Legend();
    series.slices.template.events.on("hit", (event) => { });
    Statusamchart.legend = new am4charts.Legend();

    // Position legend
    Statusamchart.legend.position = "left";
    Statusamchart.legend.fontSize = 14;
    Statusamchart.legend.labels.template.maxWidth = 12;
    Statusamchart.logo.disabled = true;
    Statusamchart.legend.valueLabels.template.position = "left";
    Statusamchart.legend.valueLabels.template.align = "left";
    Statusamchart.legend.labels.template.text =
      "[{color}] {data}   {category} ";
    Statusamchart.legend.valueLabels.template.text = "";
    Statusamchart.legend.itemContainers.template.togglable = false;
    Statusamchart.radius = am4core.percent(90);
    Statusamchart.legend.itemContainers.template.events.on("hit", (ev) => {
      if (ev.target.dataItem.dataContext.category.toUpperCase() === "OPEN") {
        ShowImplementData("status", "O");
      } else if (
        ev.target.dataItem.dataContext.category.toUpperCase() === "RESOLVED"
      ) {
        ShowImplementData("status", "R");
      } else if (
        ev.target.dataItem.dataContext.category.toUpperCase() === "REOPENED"
      ) {
        ShowImplementData("status", "K");
      } else if (
        ev.target.dataItem.dataContext.category.toUpperCase() ===
        "PENDING ON CLIENT"
      ) {
        ShowImplementData("status", "Q");
      } else {
        ShowImplementData("status", "I");
      }
    });

    let label = "Open";

    statusarray.forEach((item) => {
      const data = statusarray.find((item) => item.label === label);
      if (label === "Open") {
        label = "In Progress";
      } else if (label === "In Progress") {
        label = "Pending On Client";
      } else if (label === "Pending On Client") {
        label = "Resolved";
      } else if (label === "Resolved") {
        label = "Reopened";
      }
      updatedStatus.push(data);
    });
    Statusamchart.data = updatedStatus;
    series.colors.list = [
      am4core.color(GetColor(ImpStatusData[3].color)),
      am4core.color(GetColor(ImpStatusData[1].color)),
      am4core.color(GetColor(ImpStatusData[2].color)),
      am4core.color(GetColor(ImpStatusData[0].color)),
      am4core.color("#c20001"),
    ];
  };

  const ShowAssignee = (name) => {
    ShowImplementData("assignee", name);
  };

  const ShowTeams = (value) => {
    ShowImplementData("teams", value);
  };

  const CheckCurrentUser = (username) => {
    const name = `${sessionStorage.firstName} ${sessionStorage.lastName}`;
    if (username === name) {
      return true;
    }
    return false;
  };

  const Assigneelist = (arr) => {
    const myArray = [];
    arr.forEach((index) => {
      myArray.push(
        <li
          onClick={() => ShowAssignee(index.name)}
          className="py-1 w-50 ps-4 cursor-pointer"
          key={index.label}
        >
          <span
            className={`${CheckCurrentUser(index.name) === true
              ? "bg-green-800 border-0 text-white"
              : ""
              } listNumber text-sm`}
          >
            {index.data}
          </span>
          <span className="text-sm">{index.name.toUpperCase()}</span>
        </li>
      );
    });
    return myArray;
  };

  const TeamsList = (data) => {
    const teamArray = [];
    data.forEach((index) => {
      teamArray.push(
        <li
          className="py-1 w-50 ps-4 cursor-pointer"
          onClick={() => ShowTeams(index.label)}
          key={index.label}
        >
          <span className="listNumber text-sm">{index.data}</span>
          <span className="text-sm">{index.name.toUpperCase()}</span>
        </li>
      );
    });
    return teamArray;
  };

  return (
    <>
      <div className="row table-panel-header mb-2 mt-3">
        <div className="col-md-12 col-sm-12">
          <h2>Implementations</h2>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 col-sm-12">
          <div className="table-panel">
            <div className="table-panel-header">
              <h6>Counts</h6>
            </div>

            <section id="ImpStatus_Count" className="pieHeight" />
          </div>
        </div>
        <div className="col-md-6 col-sm-12">
          <div className="table-panel">
            <div className="table-panel-header">
              <h6>Priority</h6>
            </div>
            <section id="ImpPriority_Count" className="pieHeight" />
          </div>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-md-6 col-sm-12">
          <div className="table-panel">
            <div className="table-panel-header">
              <h6>Assignees</h6>
            </div>
            <section className="assigneeBox py-2">
              <ul className="d-flex flex-wrap mb-0 list-unstyled">
                {impAssigneeCounts.length > 0 &&
                  Assigneelist(impAssigneeCounts)}
              </ul>
            </section>
          </div>
        </div>
        <div className="col-md-6 col-sm-12">
          <div className="table-panel">
            <div className="table-panel-header">
              <h6>Teams</h6>
            </div>

            <section>
              <ul className="d-flex flex-wrap mb-0 list-unstyled">
                {impTeamCounts.length > 0 && TeamsList(impTeamCounts)}
              </ul>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default Implementation;
